import ProblemSolutionVisual from "./ProblemSolutionVisual";

const highlights = [
  "تصميم يعكس هويتك التجارية باحترافية",
  "سرعة تحميل عالية تقلل معدل الارتداد",
  "توافق كامل مع الجوال والأجهزة اللوحية",
  "تهيئة لمحركات البحث لزيادة الظهور",
];

export default function ProblemSolution() {
  return (
    <section className="section-padding relative">
      <div className="container-main">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div className="relative order-2 lg:order-1 group max-w-full overflow-hidden">
            <div className="absolute inset-0 bg-gradient-to-br from-teal-500/20 to-cyan-500/10 rounded-3xl blur-2xl opacity-60 group-hover:opacity-100 transition-opacity pointer-events-none" />
            <div className="relative v2-glass-card overflow-hidden rounded-3xl p-1">
              <ProblemSolutionVisual />
            </div>
            <div className="absolute bottom-2 left-2 sm:-bottom-4 sm:-left-4 v2-glass-card px-6 py-4 rounded-2xl border-teal-400/20">
              <div className="flex items-center gap-2 text-teal-300">
                <i className="ri-speed-up-line text-xl" />
                <span className="font-bold">أداء محسّن</span>
              </div>
            </div>
          </div>

          <div className="order-1 lg:order-2">
            <span className="v2-section-label">
              <span className="w-8 h-px bg-teal-400" />
              لماذا يحتاج مشروعك موقعًا؟
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-white mt-4 mb-6 leading-tight">
              <span className="title-line-1">موقعك هو أول</span>
              <span className="title-line-2 v2-gradient-text">انطباع</span>
            </h2>
            <p className="text-slate-400 leading-relaxed text-base md:text-lg mb-8">
              إذا كان موقعك بطيئًا، غير متوافق مع الجوال، أو لا يعكس قوة علامتك
              التجارية، فأنت تخسر فرصًا يوميًا. في أوامر الشبكة نطوّر موقعًا
              مصممًا لهدف واضح: جذب العميل، بناء الثقة، وتحويل الزيارة إلى
              تواصل.
            </p>
            <ul className="space-y-4">
              {highlights.map((item) => (
                <li key={item} className="flex items-center gap-4 group">
                  <span className="w-10 h-10 rounded-xl bg-teal-500/10 border border-teal-400/20 flex items-center justify-center flex-shrink-0 group-hover:bg-teal-500/20 transition-colors">
                    <i className="ri-check-line text-teal-400" />
                  </span>
                  <span className="text-slate-300 text-sm md:text-base">
                    {item}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
